<template>
  <component v-bind:is="elName" v-bind="elData"></component>
</template>

<script>
export default {
  name: 'ComponentWrapper',

  props: {
    elName: {
      type: String,
      required: true
    },
    elData: {
      type: Object,
      required: true
    }
  },

  /**
   * Lifecycle event: mounted
   * This fires _before_ the child component is mounted.
   */
  mounted() {
    // console.log('[ComponentWrapper] mounted')
    // setInterval(() => {
    //   this.$root.$emit("test");
    // }, 2000);
  }
}
</script>
